import { CharacterStateBase } from './_stateLibrary';
import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';

export class RunPistol extends CharacterStateBase implements ICharacterState {
    constructor(character: Character) {
        super(character);
        this.character.simulation.velocitySimulator.damping = 0.4;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.simulation.setArcadeVelocityTarget(1.1);
        this.playAnimation(CharacterAnimation.RunPistol, 0.2);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.onDie();
        this.fallInAir();
    }
}
